import React, { PureComponent } from 'react';

class Tooltip extends PureComponent {
  render() {
    if(!this.props.ttVisible) {
      return null;
    }

    const data = this.props.ttData;

    const ttStyle = {
      left: this.props.ttPosition[0],
      top: this.props.ttPosition[1]
    };

    const incomeString = data.index === 31 ? `von mehr als ${(Math.round(data.minIncome)).toLocaleString('de-DE')} Euro` :
    `von ${(Math.round(data.minIncome)).toLocaleString('de-DE')} bis ${(Math.round(data.maxIncome)).toLocaleString('de-DE')} Euro`;

    return (
      <div style={ttStyle} className="ifdw-chart--tooltip">
        { data.name === 'value' ?
          <span><strong>{(data.v1 * 100).toFixed(1).replace('.', ',')} Prozent</strong><span> der Gesamtbevölkerung haben ein bedarfsgewichtetes Monatsnettoeinkommen {incomeString}</span></span> :
          <span><strong>{(data.v1 * 100).toFixed(1).replace('.', ',')} Prozent</strong><span> der Gesamtbevölkerung gehören zur ausgewählten Teilgruppe und haben ein bedarfsgewichtetes Monatsnettoeinkommen {incomeString}</span></span>
        }
      </div>
    );
  }
}

export default Tooltip;



/** WEBPACK FOOTER **
 ** ./src/components/Barchart/Tooltip.js
 **/